module.exports = __webpack_public_path__ + "img/20200515_161038.cb59cc92.jpg";